import React from 'react'
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom'
import Login from '../component/auth/Login'
import AuthContainer from '../layouts/Auth'
import DashboardContainer from '../layouts/Dashboard'
import Home from "../component/Dashboard/Home";
import PaymentHistory from "../component/History/PaymentHistory";

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../../src/data/ActionCreators';
import Pay from "../component/Pay/Pay";
import Verify from "../component/Pay/Verify";
import ChandaCalculator from "../component/More/ChandaCalculator";


export const RootStack = (auth) => {

    return (
        <Router>
            <Switch>
                {auth.auth.data === null ? (

                        <Route path='' exact>
                            <AuthContainer>
                                <Switch>
                                    <Route path='/login' exact component={Login}/>
                                    <Route path='/' exact component={Login}/>
                                    <Redirect from='*' to='/' />


                                </Switch>
                            </AuthContainer>
                        </Route>
                    )
                    :

                    <Route path='/' >
                        <DashboardContainer>
                            <Switch>
                                <Route path='/dashboard'  component={Home}/>
                                <Route path='/history'  component={PaymentHistory}/>
                                <Route path='/pay'  component={Pay}/>
                                <Route path='/verify'  component={Verify}/>
                                <Route path='/chanda-calculator'  component={ChandaCalculator}/>
                                <Route path='/'  component={Home}/>
                                <Redirect from='*' to='/' />

                            </Switch>
                        </DashboardContainer>
                    </Route>
                }

                <Redirect from='*' to='/' />

            </Switch>
        </Router>
    )

}

// export default RootStack;
const mapStateToProps = (state) => {
    const {auth,    isAuthorized,seenOnboarding} = state;
    return {auth,    isAuthorized,seenOnboarding};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            getAuthUser: ActionCreators.getAuthenticated,
            setUpAuthorized: ActionCreators.setUpAuthorized,
            logout: ActionCreators.logout,
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RootStack);
